import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IKeyFigureGroup, ITags } from "src/api/server/extended-search";
import { Button } from "src/components/base/button";
import { PopoverButton } from "src/components/pages/search/components/popover-button";
import { NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS } from "src/components/pages/search/constants";
import { usePopularFiltersCounter } from "src/components/pages/search/hooks/use-popular-filters-counter";
import { ISearch } from "src/components/pages/search/search.types";
import { handleResetPopularFilters } from "src/components/pages/search/store/actions";
import { PopularFiltersContent } from "./components/popular-filters-content";

const POPULAR_FILTERS_POPOVER_BODY_TEST_ID = "popular-filters-popover-body";

interface IPopularFiltersPopover extends ISearch {
    popularKeyFiguresGroup: IKeyFigureGroup;
    tagsData: ITags;
}

export const PopularFiltersPopover = ({ popularKeyFiguresGroup, tagsData, onSearch }: IPopularFiltersPopover) => {
    const { t } = useTranslation("extended-search");

    const numberOfSelectedFilters = usePopularFiltersCounter();

    const { basics, rewards, tradings, investmentHorizon, investmentRegion } = tagsData;
    const numberOfPopularFilters =
        popularKeyFiguresGroup.keyFigures.length +
        basics.tags.length +
        tradings.tags.length +
        rewards.tags.length +
        investmentHorizon.tags.length +
        investmentRegion.tags.length +
        NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS;

    const handleReset = () => {
        handleResetPopularFilters({
            onSearch,
        });
    };

    return (
        <Popover placement="bottom-start" flip={false}>
            {({ isOpen }) => (
                <>
                    <PopoverTrigger>
                        <PopoverButton
                            flex={1}
                            isOpen={isOpen}
                            title={t("labels.popular-filters")}
                            badgeInfo={`${numberOfSelectedFilters} / ${numberOfPopularFilters}`}
                        />
                    </PopoverTrigger>
                    <PopoverContent rootProps={{ w: ["unset", "100%", "unset"], px: ["unset", 1, "unset"] }} w={["100%", "100%", "810px"]}>
                        <PopoverBody m={[0, 0, 0]} py={3} px={[3, 3, 3]} data-test-id={POPULAR_FILTERS_POPOVER_BODY_TEST_ID}>
                            <PopularFiltersContent popularKeyFiguresGroup={popularKeyFiguresGroup} tagsData={tagsData} onSearch={onSearch} />
                            <Box>
                                <Button variant="ghost-underline" size="sm" ml={-2} onClick={handleReset}>
                                    {t("buttons.reset-popular-filters")}
                                </Button>
                            </Box>
                        </PopoverBody>
                    </PopoverContent>
                </>
            )}
        </Popover>
    );
};
